// export const langKeys = ['en', 'zh', 'de', 'ja', 'fr', 'id', 'th'];

// export const langList = [
//   { value: 'en', name: 'English' },
//   { value: 'zh', name: '中文' },
//   { value: 'de', name: 'Deutsch' },
//   { value: 'ja', name: '日本語' },
//   { value: 'fr', name: 'Français' },
//   { value: 'id', name: 'Bahasa Indonesia' },
//   { value: 'th', name: 'ไทย' },
// ];

export const countryData = [
  { countryCode: 'AUT', countryName: 'Austria' },
  { countryCode: 'BEL', countryName: 'Belgium' },
  { countryCode: 'DNK', countryName: 'Denmark' },
  { countryCode: 'FIN', countryName: 'Finland' },
  { countryCode: 'FRA', countryName: 'France' },
  { countryCode: 'DEU', countryName: 'Germany' },
  { countryCode: 'GRC', countryName: 'Greece' },
  { countryCode: 'HUN', countryName: 'Hungary' },
  { countryCode: 'IRL', countryName: 'Ireland' },
  { countryCode: 'ITA', countryName: 'Italy' },
  { countryCode: 'LUX', countryName: 'Luxembourg' },
  { countryCode: 'NLD', countryName: 'Netherlands' },
  { countryCode: 'NZL', countryName: 'New Zealand' },
  { countryCode: 'POL', countryName: 'Poland' },
  { countryCode: 'ROU', countryName: 'Romania' },
  { countryCode: 'ESP', countryName: 'Spain' },
  { countryCode: 'SWE', countryName: 'Sweden' },
  { countryCode: 'GBR', countryName: 'United Kingdom(UK)' },
  { countryCode: 'ARE', countryName: 'United Arab Emirates' },
  { countryCode: 'USA', countryName: 'United States(US)' },
  { countryCode: 'CAN', countryName: 'Canada' },
  { countryCode: 'OTHER', countryName: 'Other' },
];

export const initI18n = [
  'en-US',
  'en-GB',
  'zh-CN',
  'ja-JP',
  'de-DE',
  'fr-FR',
  'th-TH',
  'in-ID',
  'es-ES',
  'it-IT',
];
